
// import React, { useState, useEffect } from 'react';

// const scrollToFeatures = () => {
//   const featuresSection = document.getElementById('features');
//   if (featuresSection) {
//     featuresSection.scrollIntoView({ behavior: 'smooth' });
//   }
// };

// const AnimatedHeroSection = () => {
//   const [displayText, setDisplayText] = useState('');
//   const [wordIndex, setWordIndex] = useState(0);
//   const [charIndex, setCharIndex] = useState(0);
//   const [showCursor, setShowCursor] = useState(true);
//   const [isDeleting, setIsDeleting] = useState(false);
//   const [colorIndex, setColorIndex] = useState(0);

//   // Value propositions with highlight words
//   const valueProps = [
//     { text: "Save 30% Admin Time", highlight: "Admin Time", color: "text-emerald-500" },
//     { text: "Double Client Retention", highlight: "Client Retention", color: "text-yellow-500" },
//     { text: "Streamline Client Onboarding", highlight: "Onboarding", color: "text-purple-500" },
//     { text: "Automate Payment Processing", highlight: "Payment", color: "text-blue-500" },
//     { text: "Enhance Client Experience", highlight: "Experience", color: "text-orange-500" },
//     { text: "Simplify Marketing Efforts", highlight: "Marketing", color: "text-red-500" },
//     { text: "Create Professional Program Design", highlight: "Program Design", color: "text-indigo-500" },
//     { text: "Improve Client Communication", highlight: "Communication", color: "text-teal-500" }
//   ];

//   const colors = [
//     "text-emerald-500",
//     "text-yellow-500", 
//     "text-purple-500",
//     "text-blue-500",
//     "text-orange-500",
//     "text-red-500",
//     "text-indigo-500",
//     "text-teal-500"
//   ];

//   // Typing effect
//   useEffect(() => {
//     const typingSpeed = isDeleting ? 50 : 120; // Slower typing speed (was 30/70)
//     const pauseTime = 2000; // Longer pause time (was 1500)
    
//     // Get current value prop
//     const currentProp = valueProps[wordIndex];
//     const fullText = currentProp.text;
    
//     if (!isDeleting && charIndex === fullText.length) {
//       // Complete word, pause before deleting
//       setTimeout(() => setIsDeleting(true), pauseTime);
//       return;
//     } else if (isDeleting && charIndex === 0) {
//       // Finished deleting, move to next word
//       setIsDeleting(false);
//       setWordIndex((prev) => (prev + 1) % valueProps.length);
//       setColorIndex((prev) => (prev + 1) % colors.length);
//       return;
//     }
    
//     // Set timeout for next character
//     const timeout = setTimeout(() => {
//       setCharIndex(c => isDeleting ? c - 1 : c + 1);
//       setDisplayText(fullText.substring(0, isDeleting ? charIndex - 1 : charIndex + 1));
//     }, typingSpeed);
    
//     return () => clearTimeout(timeout);
//   }, [charIndex, wordIndex, isDeleting, valueProps]);
  
//   // Blinking cursor effect
//   useEffect(() => {
//     const cursorInterval = setInterval(() => {
//       setShowCursor(prev => !prev);
//     }, 500);
    
//     return () => clearInterval(cursorInterval);
//   }, []);
  
//   // Format the display text with colored highlight word
//   const formatDisplayText = () => {
//     const currentProp = valueProps[wordIndex];
//     if (!displayText) return '';
    
//     if (displayText.includes(currentProp.highlight)) {
//       const parts = displayText.split(currentProp.highlight);
//       return (
//         <>
//           {parts[0]}
//           <span className={colors[colorIndex]}>{currentProp.highlight}</span>
//           {parts[1] || ''}
//         </>
//       );
//     }
    
//     // If we're still typing and haven't reached the highlight word yet
//     return displayText;
//   };

//   return (
//     <section className="pt-16 pb-6 md:pt-20 md:pb-8 bg-white">
//       <div className="max-w-6xl mx-auto px-4 sm:px-6">
//         <div className="text-center">
//           <div className="inline-block px-4 py-2 rounded-full border border-gray-200 text-gray-700 text-sm font-medium mb-6">
//             ✨ AI-Powered All-in-One Coaching Platform
//           </div>

//           <h1 className="text-5xl sm:text-6xl font-bold mb-6 leading-tight min-h-[80px]">
//             {formatDisplayText()}<span className={`${showCursor ? 'opacity-100' : 'opacity-0'} transition-opacity duration-100`}>_</span>
//           </h1>

//           <p className="text-xl sm:text-2xl text-gray-700 mb-8 leading-relaxed max-w-3xl mx-auto">
//             Streamline your coaching business while delivering exceptional client experiences. Health and Wellness Coaches trust our platform to replace 6+ separate tools and transform their practice.
//           </p>

//           <div className="flex flex-col sm:flex-row items-center gap-4 justify-center mt-8">
//             <a  
//               href="https://calendly.com/hyphii"
//               target="_blank"
//               rel="noopener noreferrer"
//               className="w-full sm:w-auto h-16 bg-black text-white border border-gray-200 px-6 rounded-xl hover:bg-gray-800 transition duration-300 font-medium flex items-center justify-center"
//             >
//               Get Started With a Free Demo
//             </a>
//             <button
//               onClick={scrollToFeatures}
//               className="w-full sm:w-auto h-16 bg-white text-gray-900 border border-gray-200 px-6 rounded-xl hover:bg-gray-50 transition duration-300 font-medium flex items-center justify-center"
//             >
//               Explore Features
//             </button>
//           </div>

//           {/* <div className="flex flex-col items-center mt-8 mb-2">
//             <div className="flex mb-2">
//               <div className="flex -space-x-2">
//                 {[1, 2, 3, 4, 5].map((i) => (
//                   <div key={i} className="w-7 h-7 rounded-full bg-gray-300 border-2 border-white overflow-hidden">
//                     <img 
//                       src={`avatar${i}.png`} 
//                       alt="User avatar" 
//                       className="w-full h-full object-cover"
//                     />
//                     <div className="w-full h-full bg-gray-400"></div>
//                   </div>
//                 ))}
//               </div>
//             </div>
            
//             <div className="flex text-yellow-400 mb-1">
//               <span>★★★★★</span>
//             </div>
            
//             <p className="text-gray-700">Trusted by the best</p>
//           </div> */}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default AnimatedHeroSection;
import React, { useState, useEffect } from 'react';

const scrollToFeatures = () => {
  const featuresSection = document.getElementById('features');
  if (featuresSection) {
    featuresSection.scrollIntoView({ behavior: 'smooth' });
  }
};

const AnimatedHeroSection = () => {
  const [displayText, setDisplayText] = useState('');
  const [wordIndex, setWordIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const [showCursor, setShowCursor] = useState(true);
  const [isDeleting, setIsDeleting] = useState(false);
  const [colorIndex, setColorIndex] = useState(0);

  // Value propositions with highlight words
  const valueProps = [
    { text: "Save 30% Admin Time", highlight: "Admin Time", color: "text-emerald-500" },
    { text: "Double Client Retention", highlight: "Client Retention", color: "text-yellow-500" },
    { text: "Streamline Client Onboarding", highlight: "Onboarding", color: "text-purple-500" },
    { text: "Automate Payment Processing", highlight: "Payment", color: "text-blue-500" },
    { text: "Enhance Client Experience", highlight: "Experience", color: "text-orange-500" },
    { text: "Simplify Marketing Efforts", highlight: "Marketing", color: "text-red-500" },
    { text: "Create Professional Program Design", highlight: "Program Design", color: "text-indigo-500" },
    { text: "Improve Client Communication", highlight: "Communication", color: "text-teal-500" }
  ];

  const colors = [
    "text-emerald-500",
    "text-yellow-500", 
    "text-purple-500",
    "text-blue-500",
    "text-orange-500",
    "text-red-500",
    "text-indigo-500",
    "text-teal-500"
  ];

  // Typing effect
  useEffect(() => {
    const typingSpeed = isDeleting ? 50 : 120; // Slower typing speed
    const pauseTime = 2000; // Longer pause time
    
    // Get current value prop
    const currentProp = valueProps[wordIndex];
    const fullText = currentProp.text;
    
    if (!isDeleting && charIndex === fullText.length) {
      // Complete word, pause before deleting
      setTimeout(() => setIsDeleting(true), pauseTime);
      return;
    } else if (isDeleting && charIndex === 0) {
      // Finished deleting, move to next word
      setIsDeleting(false);
      setWordIndex((prev) => (prev + 1) % valueProps.length);
      setColorIndex((prev) => (prev + 1) % colors.length);
      return;
    }
    
    // Set timeout for next character
    const timeout = setTimeout(() => {
      setCharIndex(c => isDeleting ? c - 1 : c + 1);
      setDisplayText(fullText.substring(0, isDeleting ? charIndex - 1 : charIndex + 1));
    }, typingSpeed);
    
    return () => clearTimeout(timeout);
  }, [charIndex, wordIndex, isDeleting, valueProps]);
  
  // Blinking cursor effect
  useEffect(() => {
    const cursorInterval = setInterval(() => {
      setShowCursor(prev => !prev);
    }, 500);
    
    return () => clearInterval(cursorInterval);
  }, []);
  
  // Format the display text with colored highlight word
  const formatDisplayText = () => {
    const currentProp = valueProps[wordIndex];
    if (!displayText) return '';
    
    if (displayText.includes(currentProp.highlight)) {
      const parts = displayText.split(currentProp.highlight);
      return (
        <>
          {parts[0]}
          <span className={colors[colorIndex]}>{currentProp.highlight}</span>
          {parts[1] || ''}
        </>
      );
    }
    
    // If we're still typing and haven't reached the highlight word yet
    return displayText;
  };

  return (
    <section className="pt-16 pb-6 md:pt-20 md:pb-8 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="text-center">
          <div className="inline-block px-4 py-2 rounded-full border border-gray-200 text-gray-700 text-sm font-medium mb-6">
            ✨ AI-Powered All-in-One Coaching Platform
          </div>

          {/* Fixed height container to prevent layout shifts */}
          <div className="h-24 sm:h-20 flex items-center justify-center mb-6">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold leading-tight">
              {formatDisplayText()}<span className={`${showCursor ? 'opacity-100' : 'opacity-0'} transition-opacity duration-100`}>_</span>
            </h1>
          </div>

          <p className="text-base sm:text-lg md:text-xl text-gray-700 mb-8 leading-relaxed max-w-3xl mx-auto">
            Streamline your coaching business while delivering exceptional client experiences. Health and Wellness Coaches trust our platform to replace 6+ separate tools and transform their practice.
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-4 justify-center mt-8">
            <a  
              href="https://calendly.com/hyphii"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full sm:w-auto h-14 bg-black text-white border border-gray-200 px-6 rounded-xl hover:bg-gray-800 transition duration-300 font-medium flex items-center justify-center"
            >
              Get Started With a Free Demo
            </a>
            <button
              onClick={scrollToFeatures}
              className="w-full sm:w-auto h-14 bg-white text-gray-900 border border-gray-200 px-6 rounded-xl hover:bg-gray-50 transition duration-300 font-medium flex items-center justify-center"
            >
              Explore Features
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AnimatedHeroSection;